import Actions from '../actions'
import produce from 'immer'
import $t from '../i18n'
import { VIDRO_PROVIDER } from '../consts'

const initialState = {
  variant: 'default',
  isMediaAllowed: false,
  isDownloadLinkSentLoading: false,
  isDownloadLinkSentFailure: false,
  isDownloadLinkSentSuccess: false,
  downloadLinkSentErrorMessage: null,
  isAppDownloadLinkPopUpVisible: false,
  isFileUploaded: false,
  isFileUploadLoading: false,
  isAppDownloadButtonEnabled: true,
  timeOutAppDownloadButtonDisabled: 10000,
  isNoServiceDisplay: false,
  isServiceInYourCountry: null,
  // empty feature object once remote configs from firebase is available.
  features: {
    allow_family_for_all: true,
    billing_enabled: true,
    dynamic_enabled: true,
    vcc_enabled: true
  },
  locationState: null,
  twilioToken: null,
  validStates: [],
  validSubscriptionStates: [],
  resetIdleTimer: () => {},
  availableServices: [],
  alertMessage: null,
  searchUrl: '',
  messageConfig: null, //messageConfig = { type , content, duration}
  isMinorApp: false,
  languages: null,
  isHmoWelcomeDialogNeedToBeVisible: false,
  isNewProviderDirectoryDialogNeedToBeVisible: false,
  providersSearchNoLocation: false,
  antidoteSupportPhone: '‍1-866-256-2134',
  antidoteSupportEmail: '‍support@antidotehealth.com',
  nirvanaSupportPhone: '(888) 623-3195',
  links: {},
  featuresFlags: {},
  inviteToDownloadAppPatientId: null,
  isInviteToDownloadAppLoading: false,
  inviteToDownloadAppError: false,
  isBeneficDentalCardEnabled: true,
  isHmoPolicyConcentDialogVisible: false,
  hgTestResultsEnabled: false,
  isHmoPrivacyConcentAgreed: false,
  videoProvider: VIDRO_PROVIDER.ZOOM
}

const appReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPERATION_FAILED:
      return {
        ...draft
      }

    case Actions.DOWNLOAD_LINK_REQUESTED_THROUGH_SMS: {
      draft.isDownloadLinkSentLoading = true
      draft.isDownloadLinkSentSuccess = false
      draft.isDownloadLinkSentFailure = false
      draft.downloadLinkSentErrorMessage = null
      break
    }
    case Actions.MESSAGE_DISPLAY_APPROVED: {
      //{ type , content, duration}
      draft.messageConfig = { ...action?.payload, timestamp: Date.now() }
      break
    }

    case Actions.DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_SUCCESS: {
      draft.isDownloadLinkSentLoading = false
      draft.isDownloadLinkSentFailure = false
      draft.isDownloadLinkSentSuccess = true
      draft.downloadLinkSentErrorMessage = null
      break
    }

    case Actions.DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_FAILURE: {
      const { error } = action?.payload || {}
      draft.isDownloadLinkSentLoading = false
      draft.isDownloadLinkSentFailure = true
      draft.isDownloadLinkSentSuccess = false
      draft.downloadLinkSentErrorMessage = error?.body?.detail
        ? error?.body?.detail
        : $t('errors.somethingWentWrong')
      break
    }

    case Actions.MEDIA_ACCESS_ALLOWED: {
      draft.isMediaAllowed = action?.payload
      break
    }
    case Actions.SHOW_APP_DOWNLOAD_LINK_POP_UP: {
      draft.isAppDownloadLinkPopUpVisible = true
      break
    }
    case Actions.CLOSE_APP_DOWNLOAD_LINK_POP_UP: {
      draft.isAppDownloadLinkPopUpVisible = false
      draft.isAppDownloadButtonEnabled = false
      break
    }
    case Actions.ENABLE_DOWNLOAD_LINK_BUTTON: {
      draft.isAppDownloadButtonEnabled = true
      break
    }
    case Actions.UPLOAD_FILE_REQUESTED: {
      draft.isFileUploaded = false
      draft.isFileUploadLoading = true
      break
    }
    case Actions.UPLOAD_FILE_RECEIVED: {
      draft.isFileUploaded = true
      draft.isFileUploadLoading = false
      break
    }
    case Actions.UPLOAD_FILE_FAILED: {
      draft.isFileUploaded = false
      draft.isFileUploadLoading = false
      break
    }
    case Actions.NOT_SERVICE_POPUP_SHOWED: {
      draft.isNoServiceDisplay = true
      break
    }
    case Actions.NOT_SERVICE_POPUP_CLOSED: {
      draft.isNoServiceDisplay = false
      break
    }
    case Actions.VALIDATE_STATE_REQUESTED: {
      draft.validStates = []
      break
    }
    case Actions.VALIDATE_COUNTRY_RECEIVED: {
      draft.isServiceInYourCountry = action?.payload.is_valid_ip
      draft.locationState = action?.payload?.location_state
      draft.availableServices = action?.payload?.available_services
      break
    }
    case Actions.INVALID_IP_RECIEVED:
    case Actions.INVALIDATE_COUNTRY_RECEIVED: {
      draft.isServiceInYourCountry = false
      break
    }
    case Actions.VALIDATE_STATE_RECEIVED: {
      draft.isServiceInYourCountry = action?.payload.is_valid_state
      draft.locationState = action?.payload?.location_state
      draft.validStates = action?.payload?.valid_states
      draft.validSubscriptionStates =
        action?.payload?.valid_us_subscription_states
      draft.availableServices = action?.payload?.available_services
      break
    }
    case Actions.VALIDATE_STATE_RECEIVED_EXTERNAL: {
      draft.isServiceInYourCountry = action?.payload.is_valid_state
      draft.locationState = action?.payload?.location_state
      draft.validStates = action?.payload?.valid_states
      draft.validSubscriptionStates =
        action?.payload?.valid_us_subscription_states
      break
    }
    case Actions.LOCATION_VERIFICATION_FILLED: {
      draft.isNoServiceDisplay = false
      break
    }
    case Actions.FEATURE_ENABLED: {
      draft.features = Object.assign(draft.features, action?.payload)
      break
    }
    case Actions.TWILIO_TOKEN_RECEIVED: {
      const { payload } = action
      draft.twilioToken = payload.token
      break
    }
    case Actions.END_CONNECTIVITY_TEST: {
      draft.twilioToken = null
      break
    }
    case Actions.STORE_RESET_HANDLER: {
      const { reset } = action.payload
      draft.resetIdleTimer = reset
      break
    }
    case Actions.BOT_ABORTED:
    case Actions.NO_SHIFTS: {
      draft.alertMessage = $t('alerts.noShifts')
      break
    }
    case Actions.SHOW_NO_AVALIBILITY: {
      const reason = action.payload?.reason
      if (reason) {
        draft.alertMessage = $t(`alerts.${reason}`)
      }
      break
    }
    case Actions.CLEAR_ALERT: {
      draft.alertMessage = null
      break
    }
    case Actions.STORE_SEARCH_URL: {
      draft.searchUrl = action.payload.searchUrl
      break
    }
    case Actions.INIT_KIDS_APP: {
      draft.isMinorApp = true
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      draft.isMinorApp = false
      draft.messageConfig = null
      draft.isHmoPrivacyConcentAgreed = false
      draft.isHmoPolicyConcentDialogVisible = false
      break
    }
    case Actions.SYSTEM_LANGUAGES_RECEIVED: {
      draft.languages = action.payload.languages
      break
    }
    case Actions.IS_SIGNED_IN_RECEIVED: {
      // after signin, if the hmo welcome dialog was not displayed yet, display it
      // after closing the modal we are setting 'true' to the local variable in order to not present the welcome message for the specific session
      // when removing the token (on signout) the local variable will be removed as well
      draft.isHmoWelcomeDialogNeedToBeVisible = !localStorage.getItem(
        'welcomeHmoDisplayed'
      )
      draft.isNewProviderDirectoryDialogNeedToBeVisible = !localStorage.getItem(
        'newProviderDirectoryDisplayed'
      )
      break
    }
    case Actions.HMO_WELCOME_DIALOG_CLOSED: {
      // after closing the modal we are setting 'true' to the local variable in order to not present the welcome message for the specific session
      localStorage.setItem('welcomeHmoDisplayed', true)
      draft.isHmoWelcomeDialogNeedToBeVisible = false
      break
    }
    case Actions.NEW_PROVIDER_DIRECTORY_DIALOG_CLOSED: {
      // after closing the modal we are setting 'true' to the local variable in order to not present the new provider directory dialog for the specific session
      localStorage.setItem('newProviderDirectoryDisplayed', true)
      draft.isNewProviderDirectoryDialogNeedToBeVisible = false
      break
    }
    case Actions.BENEFIT_FEATURE_FLAG_RECEIVED: {
      draft.isBeneficDentalCardEnabled = action.payload?.isEnabled
      break
    }
    case Actions.APP_CONFIG_RECEIVED: {
      draft.hgTestResultsEnabled = action.payload?.hgTestResultsEnabled
      draft.providersSearchNoLocation =
        action.payload?.providersSearchNoLocation
      draft.antidoteSupportPhone =
        action.payload?.antidoteSupportPhone || draft.antidoteSupportPhone
      draft.antidoteSupportEmail =
        action.payload?.antidoteSupportEmail || draft.antidoteSupportEmail
      draft.nirvanaSupportPhone =
        action.payload?.nirvanaSupportPhone || draft.nirvanaSupportPhone
      draft.links = action.payload?.frontendUrls || {}
      draft.featuresFlags = action.payload?.featuresFlags || {}
      break
    }
    case Actions.CONFIG_VIDEO_PRIVDER_RECEIVED: {
      draft.videoProvider = action.payload?.provider || {}
      break
    }
    case Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_PRESSED: {
      draft.inviteToDownloadAppPatientId = action.payload?.patientId
      break
    }
    case Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_REQUESTED: {
      draft.isInviteToDownloadAppLoading = true
      draft.inviteToDownloadAppError = false
      break
    }
    case Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_RECEIVED: {
      draft.inviteToDownloadAppPatientId = null
      draft.isInviteToDownloadAppLoading = false
      draft.inviteToDownloadAppError = false
      break
    }
    case Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_FAILED: {
      draft.isInviteToDownloadAppLoading = false
      draft.inviteToDownloadAppError = true
      break
    }
    case Actions.SHOW_HMO_PRIVACY_CONCENT_DIALOG: {
      // present the hmo privacy concent only if the user did not agree to it yet in the same session
      // this can happen if the user aggrees to the concent and we didn't get the new concent yet from BE
      // this will prevent the user from seeing the concent again
      draft.isHmoPolicyConcentDialogVisible = !draft.isHmoPrivacyConcentAgreed
      break
    }
    case Actions.HMO_PRIVACY_CONCENT_AGREED: {
      draft.isHmoPrivacyConcentAgreed = true
      draft.isHmoPolicyConcentDialogVisible = false
      break
    }
    case Actions.CLOSE_HMO_PRIVACY_CONCENT_DIALOG: {
      draft.isHmoPolicyConcentDialogVisible = false
      break
    }
    default:
      return draft
  }
}, initialState)

export default appReducer
